var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60487 0L9.51095 0.868022L4.36897 5.63072L10.2933 5.30319L0.319875 13.9173L4.98754 7.66969L0 7.99552L4.60487 0Z",
    fill: "#2E3192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73676 0.289062L0.46875 7.7025L5.53604 7.36903L1.9706 12.1428L9.53762 5.60837L3.65574 5.93165L8.94112 1.03321L4.73676 0.289062Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04053 11.2152L9.53164 5.60996L3.64975 5.93324L8.93513 1.03479L5.11769 0.359375L1.03125 7.45378L6.09942 7.12031L3.04053 11.2152Z",
    fill: "#9DDCF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33197 5.67401L3.65921 5.9311L8.94458 1.03265L8.00953 0.867188C6.80889 1.00889 5.20351 1.87352 3.7568 3.26423C3.47764 3.53236 3.21798 3.80813 2.9787 4.08644L1.26811 7.05623C1.23332 7.1886 1.20617 7.31672 1.1875 7.44145L6.10802 7.11817L5.05331 8.53009C5.7737 8.12366 6.52208 7.56704 7.23229 6.88483C7.64296 6.49113 8.01039 6.08384 8.33197 5.67401Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.91c4bfbed060cf63836afb5bfb4c6886.svg";
export { ForwardRef as ReactComponent };